import axios from "axios";

export const getAll = (filtro) => {
  const queryString = Object.keys(filtro).map((key) => `${key}=${filtro[key]}`).join('&');
  return axios.get(`/historico-gestao-usuario?${queryString}`);
};

